/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import * as actions from '../../types/settings.type';

export const setSettings = (data: any) => ({
  type: actions.SET_SETTINGS,
  payload: data,
});

export const setSettingsSuccess = (data: any) => ({
  type: actions.SET_SETTINGS_SUCCESS,
  payload: data,
});

export const setSettingsFailure = (error: any) => ({
  type: actions.SET_SETTINGS_FAILURE,
  payload: error,
});

export const updateSettings = (data:any) => ({
  type: actions.SAVE_SETTINGS,
  payload: data,
});

export const updateSettingsSuccess = () => ({
  type: actions.SAVE_SETTINGS_SUCCESS,
});

export const updateSettingsFailure = (error: any) => ({
  type: actions.SAVE_SETTINGS_FAILURE,
  payload: error,
});

export const getSettings = (data:any) => ({
  type: actions.GET_SETTINGS,
  payload: data,
});

export const getSettingsSuccess = (data:any) => ({
  type: actions.GET_SETTINGS_SUCCESS,
  payload: data,
});

export const getSettingsFailure = (error: any) => ({
  type: actions.GET_SETTINGS_FAILURE,
  payload: error,
});

export const clearSettings = () => ({
  type: actions.CLEAR_SETTINGS,
});
